<div class="mb-6">
    <app-header [id]="id"></app-header>
</div>


<div class="lg:pt-2 bg-gray-20 lg:border-b border-gray-300">
    <div class=" container mx-auto lg:px-16 lg:mb-20 px-3 space-y-4 ">

        <div class="p-4 space-y-6">
            <h2 class="text-xl font-bold">Guests Information <span class="text-gray-500">(Optional)</span></h2>
            <p class="text-gray-600">Add the names and contact information for everyone attending the event. You can add
                this information later.</p>

            <div class="overflow-visible">
                <form [formGroup]="form" (ngSubmit)="onSubmit()">

                    <div formArrayName="guests" class="space-y-6">
                        <ng-container *ngFor="let group of groupedGuests">
                            <!-- Título del ticket -->
                            <h3 class="text-lg font-semibold text-gray-800 mt-6 mb-2">{{ group.ticketName }}</h3>

                            <!-- Invitados del ticket -->
                            <ng-container *ngFor="let guest of group.guests">
                                <div [formGroup]="guest"
                                    class="flex flex-wrap md:flex-nowrap gap-4 items-end border-b pb-4">

                                    <div class="w-full" [ngClass]="meals.length > 0 ? 'md:w-1/4' : 'md:w-1/3'">
                                        <label class="block text-base font-medium mb-1">First Name</label>
                                        <input type="text" formControlName="name"
                                            class="w-full p-inputtext p-component border rounded px-3 py-2" />
                                    </div>

                                    <div class="w-full" [ngClass]="meals.length > 0 ? 'md:w-1/4' : 'md:w-1/3'">
                                        <label class="block  text-base font-medium mb-1">Last Name</label>
                                        <input type="text" formControlName="lastName"
                                            class="w-full p-inputtext p-component border rounded px-3 py-2" />
                                    </div>

                                    <div class="w-full" [ngClass]="meals.length > 0 ? 'md:w-1/4' : 'md:w-1/3'">
                                        <label class="block  text-base font-medium mb-1">Email</label>
                                        <input type="email" formControlName="email"
                                            class="w-full p-inputtext p-component border rounded px-3 py-2" />
                                    </div>
                                    <ng-container *ngIf="meals.length > 0">
                                        <div class="w-full" [ngClass]="meals.length > 0 ? 'md:w-1/4' : 'md:w-1/3'">
                                            <label class="block  text-base font-medium mb-1">Meal choice</label>
                                            <p-select formControlName="meal" [appendTo]="'body'"
                                                 placeholder="Select meal" panelStyleClass="text-sm"
                                                class="w-full text-base" [options]="meals" optionLabel="name"
                                                optionValue="id">
                                            </p-select>

                                            <!-- <p-select id="state" formControlName="state" class="w-full text-sm"
                                            [options]="states" optionLabel="name" optionValue="abbreviation"
                                            placeholder="{{placeHolderState}}">
                                        </p-select> -->
                                        </div>
                                    </ng-container>

                                </div>
                            </ng-container>
                        </ng-container>
                    </div>


                    <div class="flex gap-2 pt-20 ">

                        <button pButton type="button"
                            class=" h-[40px] lg:h-[35px] !bg-white !border 
                            !border-[var(--p-info-500)] 
                            hover:!border-[var(--p-info-600)] 
                            active:!border-[var(--p-info-700)] !text-[var(--p-info-500)] px-4 py-2 font-medium text-base flex-[1] !rounded-full flex justify-end items-center"
                            (click)="goBack()">
                            <i class="pi pi-angle-double-left text-xl"></i>
                            <span class="font-semibold  text-center w-full text-base">
                                Back
                            </span>
                        </button>

                        <button pButton class=" h-[40px] lg:h-[35px] p-button-info rounded-m w-full relative flex-[4] flex items-center
                        justify-center gap-2" [rounded]="true"
                            (click)="isAuthenticated().isAuthenticated ? embeddedPaymentLoad() : openLoginModal() ">
                            <i class="pi pi-angle-double-right !text-[var(--p-text-color-secondary)] text-lg left-3">
                            </i>
                            <span class="font-semibold !text-[var(--p-text-color-secondary)] text-center w-full text-base">
                                {{hasGuestData ? 'Save & Continue' : 'Skip' }}
                            </span>
                        </button>

                        <app-embedded-payment [token]="token" [(visible)]="visibleEmbedded"></app-embedded-payment>


                        <app-zero-purchase-thankyou-page *ngIf="thankYouData" [thankYouData]="thankYouData"
                            [(visible)]="showThankYouPageModal">
                        </app-zero-purchase-thankyou-page>
                        <!-- <div *ngIf="isShowingLoginIframe" class="border border-solid border-[#19a6df] rounded-xl">
                        <app-sign-in [loginPage]="loginPage" [loginUrl]="loginUrl()"></app-sign-in>
                    </div> -->
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

@if(loadingEPF()){
<div class="fixed inset-0 z-50 flex items-center justify-center min-h-[300px]">
    <p-progress-spinner ariaLabel="loading" />
</div>
}


<div>
    <app-footer></app-footer>
</div>